/* eslint-disable */
// import core & vendor packages below
import axios from 'axios';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { Row, Col, Form, Button } from 'react-bootstrap';

// import components below
import FormUI from 'components/UI/FormUI';

// import assets below
import './Filter.scss';

// main component
const DoctorFilter = ({ state, setState, setShowProfile }) => {
  const [word, setWord] = useState('');
  const [id, setId] = useState('');
  const [MRN, setMRN] = useState('');
  const [patients, setPatients] = useState([]);

  const resetFilter = () => {
    setState(patients);
    setWord('');
    setId('');
    setMRN('');
  };

  // Search Patient by name
  const onChangeHandler = (event) => {
    const searchedWord = event.target.value;
    setWord(event.target.value);

    const newFilter = patients.filter((value) => {
      return value.patient.full_name.toLowerCase().includes(searchedWord.toLowerCase());
    });

    if (searchedWord.length > 0) {
      setState(newFilter);
    } else {
      setState(patients);
    }
  };

  // Search patient by ID
  const onChangeHandlerPhysicianName = (event) => {
    const searchedWord = event.target.value;
    setId(event.target.value);

    const newFilter = patients.filter((value) => {
      // return String(value.patient) === String(searchedWord);
      return value.patient.toLowerCase().includes(searchedWord.toLowerCase());
    });

    if (searchedWord.length > 0) {
      setState(newFilter);
    } else {
      setState(patients);
    }
  };

  // search by patient MRN
  const onChangeHandlerMRN = (event) => {
    const searchedWord = event.target.value;
    setMRN(event.target.value);

    const newFilter = patients.filter((value) => {
      // return String(value.patient.MRN) === String(searchedWord);
      return value.ctp_code.toLowerCase().includes(searchedWord.toLowerCase());
    });

    if (searchedWord.length > 0) {
      setState(newFilter);
    } else {
      setState(patients);
    }
  };

  const handleFeeModal = () => {
    setShowProfile((prev) => {
      return {
        ...prev,
        showDoctorFee: true,
      };
    });
  };

  useEffect(() => {
    axios
      .get('/requisition/procedure')
      .then((response) => {
        setState(response.data.data);
        setPatients(response.data.data);
      }, [])
      .catch((err) => {
        console.log('AXIOS ERROR: ', err);
      });
  }, []);

  return (
    <div className='doctorFilter'>
      <FormUI>
        <Row className='custom'>
          <Col md={1} className='container-tb'>
            <Form.Group className='mb-3 text-box'>
              <Form.Label>Patient Name</Form.Label>
              <Form.Control
                type='text'
                placeholder='Enter here'
                value={id}
                onChange={onChangeHandlerPhysicianName}
              />
            </Form.Group>
          </Col>

          <Col md={2} className='container-tb'>
            <Form.Group className='mb-3 text-box'>
              <Form.Label>Surgery Code</Form.Label>
              <Form.Control
                type='text'
                placeholder='Enter here'
                value={MRN}
                onChange={onChangeHandlerMRN}
              />
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col>
            <div className='patient-header'>
              <h4 className='mb-0 fw-bold'>Patient List</h4>
            </div>
          </Col>
          <Col>
            <div className='buttonWrapper'>
              {/* <Button onClick={handleFeeModal} className='primary fee'>
                Professional Fee
              </Button> */}
              <Button variant='clear' onClick={resetFilter}>
                Reset
              </Button>
            </div>
          </Col>
        </Row>
      </FormUI>
    </div>
  );
};

DoctorFilter.defaultProps = {
  state: [],
  setState: () => {},
};

DoctorFilter.propTypes = {
  state: PropTypes.array,
  setState: PropTypes.func,
};

export default DoctorFilter;
